import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_licenseplate_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { locationId: number, lotId: number, packagedId: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, TotalPackagedAmount?: number, LicensePlate?: { CreatedSysDateTime?: string, LookupCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.locationId)) {
      $missingRequiredInParams.push('\'locationId\'');
    }
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.packagedId)) {
      $missingRequiredInParams.push('\'packagedId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { locationId: number, lotId: number, packagedId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, TotalPackagedAmount?: number, LicensePlate?: { CreatedSysDateTime?: string, LookupCode?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.locationId)) {
      $missingRequiredInParams.push('\'locationId\'');
    }
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.packagedId)) {
      $missingRequiredInParams.push('\'packagedId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { locationId: number, lotId: number, packagedId: number, $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, AvailablePackagedAmount?: number, TotalPackagedAmount?: number, LicensePlate?: { CreatedSysDateTime?: string, LookupCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.locationId)) {
      $missingRequiredInParams.push('\'locationId\'');
    }
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.packagedId)) {
      $missingRequiredInParams.push('\'packagedId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      locationId: number, lotId: number, packagedId: number    }) {
        if(isNil($inParams.locationId)) {
          return true; 
        }
        if(isNil($inParams.lotId)) {
          return true; 
        }
        if(isNil($inParams.packagedId)) {
          return true; 
        }
      return false;
    }
}
